'use strict';

window.CFC = window.CFC || {};
window.CFC.Recipe = (function($) {
  var conversions = [{
    names: [ 'cup','cups','tasse','tasses' ],
    factor: 236.588,
    roundto: 5,
    unit: [ 'mL', 'ml' ],
    lookup: {
      '0.125': 30,
      '0.250': 60,
      '0.333': 75,
      '0.500': 125,
      '0.666': 150,
      '0.750': 175,
      '1.000': 250,
      '1.333': 325
    },
    scale: { '1000': [ 'L', 'l' ] }
  },{
    names: [ 'tsp', 'c. à thé' ],
    factor: 4.92892,
    roundto: 0.5,
    unit: [ 'mL', 'ml' ],
    lookup: {
      '0.125': 0.5,
      '0.250': 1.25,
      '0.500': 2.5,
      '1.000': 5
    }
  },{
    names: [ 'tbsp', 'c. à table', 'c. à soupe' ],
    factor: 14.7868,
    roundto: 0.5,
    unit: [ 'mL', 'ml' ],
    lookup: {
      '1.000': 15,
      '1.500': 25,
      '2.000': 30
    }
  },{
    names: [ 'oz', 'onces' ],
    factor:  28.3495,
    roundto: 5,
    unit: [ 'g', 'g' ]
  },{
    names: [ 'lb', 'lbs' ],
    factor: 0.453592,
    roundto: 0.1,
    unit: [ 'kg', 'kg' ]
  },{
    names: [ 'fl oz' ],
    factor: 29.574,
    roundto: 5,
    unit: [ 'mL', 'ml' ]
  }];
  
  var isFr;
  
  function init() {
    isFr = $('body').hasClass('lang--fr');
    
    $('.ingredients__unitButton').on('click', function(e) {
      var $this = $(this);
      
      if ($this.hasClass('selected')) { return; }
      
      var unitType = $this.data('unitType');
      updateUnits($this.closest('.recipe__ingredients'), unitType);
      
      var $unitButtons = $this.closest('.ingredients__unitButtons').find('.ingredients__unitButton');
      $unitButtons.removeClass('selected');
      $unitButtons.filter('[data-unit-type=' + unitType + ']').addClass('selected');
    });
  }
  
  function updateUnits($container, unitType) {
    $container.find('.ingredient').each(function() {
      var $ingredient = $(this);
      var origAmount = { unit : $ingredient.data('unit') || '', amount: $ingredient.data('amount') || '' };
      var updatedAmount = translateAmount(origAmount, unitType);

      var separator = (updatedAmount.amount && updatedAmount.unit) ? ' ' : '';
      var updatedString = updatedAmount.amount + separator + updatedAmount.unit;
      
      $ingredient.find('.ingredient__amount').text(updatedString);
    });
  }
  
  function translateAmount(fromAmount, unitType) {
    // We currently only need to do imperial -> metric conversions
    if (unitType !== 'metric') { return fromAmount; }
    
    var conversion = getConversionForUnit(fromAmount.unit);
    
    if (!conversion) { return fromAmount; }
    
    var amount = decimalFromMaybeFraction(fromAmount.amount);
    var unit = conversion.unit[isFr ? 1 : 0];
    var amount = convertAmount(amount, conversion);
    
    if (conversion.scale) {
      var scales = Object.getOwnPropertyNames(conversion.scale);
      
      for (var i = 0; i < scales.length; i++) {
        var testScale = scales[i];
        
        if (amount > testScale) {
          amount /= testScale;
          unit = conversion.scale[testScale][isFr ? 1 : 0];
          break;
        }
      };
    }
      
    var amountStr = amount + '';
    
    if (isFr) {
      amountStr = amountStr.replace('.', ',');
    }

    return { amount: amountStr, unit: unit };
  }
  
  function convertAmount(amount, conversion) {
    var factor = null;
    
    if (conversion.lookup) {
      var lookupKey = Number(amount).toFixed(3);
      var lookupVal = conversion.lookup[lookupKey];
      
      if (lookupVal) {
        return lookupVal;
      }
      
      // If there's a 1.0 conversion, use that instead of the real factor, for prettier final numbers
      factor = conversion.lookup['1.000'];
    }
    
    factor = (factor || conversion.factor);
    
    // Multiply by conversion factor
    amount = amount * factor;
    
    // Round to appropriate multiple
    amount = getRounded(amount, conversion.roundto);
    return amount;
  }

  /** 
   * Converts a number into something appropriate for display.  Rounds to the requested precision, and then
   * reduces to a reasonable precision and trims any excess zeroes to account for floating point errors.
   */
  function getRounded(amount, roundTo) {
    amount = Math.ceil(amount / roundTo) * roundTo;
    amount = amount.toFixed(3);
    
    amount = amount.replace(/\.0+$/, '');
    
    if (-1 !== amount.indexOf('.')) {
      amount = amount.replace(/0+$/, '');
    }
    
    return amount;
  }
  
  function decimalFromMaybeFraction(amount) {
    if (!amount) { 
      return amount;
    }

    amount = '' + amount;
    amount = amount.trim();
    amount = amount
      .replace('½', '1/2')
      .replace('¼', '1/4')
      .replace('¾', '3/4')
      .replace('⅓', '1/3')
      .replace('⅔', '2/3');

    if (amount.match(/^[\d\.]+$/)) {
      return Number(amount);
    }
    
    var match = amount.match(/^(?<whole>\d+\s+)?(?<numerator>\d+)\/(?<denominator>\d+)$/);
    
    if (match) {
      var groups = match.groups;
      var result = Number(groups.numerator) / Number(groups.denominator);
      result += (groups.whole) ? Number(groups.whole) : 0;
      
      return result;
    }

    return amount;
  }
  
  function getConversionForUnit(unit) {
    var testUnit = unit.trim();
    
    var matchingConversions = conversions.filter(function(conversionType) {
      var matchingNames = conversionType.names.filter(function(name) { return name === testUnit; });
      return !!matchingNames.length;
    });
    
    return matchingConversions.shift();
  }
  
  
  $(init);
})(jQuery);